import { Link as MuiLink } from '@mui/material';
import { MouseEvent, PropsWithChildren } from 'react';
import { Link as RouterLink } from 'react-router';

interface Props extends PropsWithChildren {
  to: string;
}

export const TableRowLink = ({ children, to }: Props) => (
  <MuiLink
    color="inherit"
    component={RouterLink}
    onClick={(event: MouseEvent) => event.stopPropagation()}
    sx={{ '&:hover': { textDecoration: 'underline' }, textDecoration: 'none' }}
    to={to}
    viewTransition
  >
    {children}
  </MuiLink>
);
